import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js'
import builderConstructor from '@components/ui-components/builder/constructor/component.js'
import tagsBlock from '@components/ui-components/tags/tags.vue'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'page-form-cmp': PageForm,
    'banner-btn-cmp': BannerBtn,
    'tags-cmp': tagsBlock,
    'builder-constructor': builderConstructor,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    getName(name) {
      let mass = name.split(' ')
      mass = mass.filter((item, index) => index < 2)
      let result = ''
      mass.forEach(item => {
        result = result + item.split('')[0]
      })
      return result
    },
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/cases/view/index.js